import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class CalendarService {
    private date = new Date();
    private closeCalendar = false;
    private editFutureDay = true;

    private closeCalendarSubject$ = new BehaviorSubject<(boolean)>(false);
    private updateDateSubject$ = new BehaviorSubject<(Date)>(this.date);

    readonly closeCalendar$ = this.closeCalendarSubject$.asObservable();
    readonly updateDate$ = this.updateDateSubject$.asObservable();

    manageCalendar(closeCalendar: boolean): void {
        this.closeCalendar = closeCalendar;
        this.next();
    }

    updateDate(newDate: Date): void {
        this.date = newDate;
        this.nextDate();
    }

    updateEditFutureDay(futureDay: boolean): void {
        this.editFutureDay = futureDay;
    }

    getEditFutureDay(): boolean {
        return this.editFutureDay;
    }

    resetDate(): void {
        this.date = new Date();
        this.nextDate();
    }

    private next(): void {
        this.closeCalendarSubject$.next(this.closeCalendar);
    }

    private nextDate(): void {
        this.updateDateSubject$.next(this.date);
    }
}
